import { isNumber, isString } from 'class-validator';

export const SELF_CHECKIN_RADIUS_LIMIT_MILES = 1;

export const GATE_MANAGEMENT_SALES_URL =
  'https://lp.opendock.com/gate-management?utm_source=opendockapp&utm_medium=cta&utm_campaign=od-gate-management-warehouse-opendock-q4-24&utm_content=appt-details';

export const GATE_MANAGEMENT_USER_EMAIL = 'gatemanagement@example.com';

export const SELF_CHECKIN_LEAD_TIME_MINUTES = 60 * 24;

// Shared with SmsPanel, which repeats the same gate at panel level. Keep both in sync.
export const SMS_COUNTRIES: readonly string[] = ['USA', 'CAN'];

export function milesToMeters(miles: number): number {
  if (isNumber(miles) || isString(miles)) {
    return Number(miles) * 1609.34;
  }
  throw new Error(`Invalid miles ${miles}`);
}
export interface ICheckInPrimaryField {
  label: string;
  key: string;
  type: string;
  description: string;
  requiredForDrivers: boolean;
  requiredForWarehouse: boolean;
}

export const CheckInPrimaryFields: ICheckInPrimaryField[] = [
  {
    label: 'Asset Type',
    key: 'assetType',
    type: 'singleSelect',
    description: '',
    requiredForDrivers: true,
    requiredForWarehouse: true
  },
  {
    label: 'Asset ID',
    key: 'assetId',
    type: 'number',
    description: '',
    requiredForDrivers: true,
    requiredForWarehouse: true
  },
  {
    label: "Driver's Phone Number",
    key: 'driversPhoneNumber',
    type: 'number',
    description: '',
    requiredForDrivers: true,
    requiredForWarehouse: true
  },
  {
    label: 'Carrier Company',
    key: 'carrierCompany',
    type: 'singleSelect',
    description: '',
    requiredForDrivers: true,
    requiredForWarehouse: true
  },
  {
    label: 'Reference Number',
    key: 'referenceNumber',
    type: 'text',
    description: '',
    requiredForDrivers: false,
    requiredForWarehouse: false
  },
  {
    label: 'License Plate',
    key: 'licensePlate',
    type: 'text',
    description: '',
    requiredForDrivers: false,
    requiredForWarehouse: false
  },
  {
    label: 'DOT Number',
    key: 'dotNumber',
    type: 'text',
    description: '',
    requiredForDrivers: false,
    requiredForWarehouse: false
  },
  {
    label: 'Driver Notes',
    key: 'driverNotes',
    type: 'text',
    description: '',
    requiredForDrivers: false,
    requiredForWarehouse: false
  }
];
